
const tabBase = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "150px",
};

export const useStyles = (theme) => ({
  tabBase: {
    height: "50px",
    [theme.breakpoints.down('sm')]: {
      height: "40px",
      borderRadius: "0 5px 5px 0",
    },
    backgroundColor: "rgba(44,58,72, 0.5)",
    cursor: "pointer",
    display: "flex",
    "& p": {
      color: "#ffffff",
      fontSize: "12px",
      fontWeight: "500",
      fontFamily: "Inter",
      [theme.breakpoints.down('sm')]: {
        fontSize: "8px",
      },
    },
    width: "100%",
    "userSelect": "none",
    "MozUserSelect": "none",
    "WebkitUserSelect": "none",
  },
  tabFree: {
    ...tabBase,
    height: "100%",
    "& p": {
      opacity: 0.7,
    },
    borderBottom: "solid 6px rgba(1,1,1,0)",
  },
  tabSelected: {
    ...tabBase,
    height: "100%",
    "& p": {
      opacity: 1.0,
      color: "#19b2ab",
    },
    borderBottom: "solid 6px #19b2ab",
  },
  chartContainer: {
    color: "#fff",
    maxWidth: "calc(100dvw - 150px)",
    margin: "auto",
    padding: "18px 18px 0 18px",
    "userSelect": "none",
    "MozUserSelect": "none",
    "WebkitUserSelect": "none",
    maxHeight: "calc(100dvh - 140px)",
    overflow: "auto",
    [theme.breakpoints.down("sm")]: {
      overflow: "auto",
    },
  },
  titleContainer: {
    display: "flex",
    gap: "40px",
    marginBottom: "12px",
    alignItems: "center",
    padding: "10px 0px 10px 0px",
  },
  chartTitle: {
    fontSize: "18px",
  },
  lastUpdate: {
    color: "rgba(255, 255, 255, 0.5)",
  },
  chartSubtitleLeft: {
    color: "rgba(255, 255, 255, 0.5)",
  },
  chartSubtitleRight: {
    display: "flex",
    alignItems: "center",
    justifyContent: "end",
  },
  maximize: {
    padding: "0 12px !important",
  },
  chartController: {
    padding: "105px 0 0 20px",
  },
  circle: {
    margin: "20px 20px",
    position: "relative",
    left: "calc(50% - 20px)",
    top: "calc(50% - 20px)",
  },
});